import Vue from'vue';export default{pixelWidth:102,get ratio(){return{width:this.pixelWidth/this.widths.xs,height:this.pixelWidth/this.widths.xs}},step:33.3,initial_step:33.3,heights:{xs:15,s:20,m:25,l:33},widths:{xs:33.3,s:67,m:100,l:133,xl:166,xxl:200}};


//////////////////
// WEBPACK FOOTER
// ./app/components/data/krossing.js
// module id = 212
// module chunks = 0